module.exports = __webpack_public_path__ + "static/media/ico_webex.6d0ccc5e.svg";